import http from "../shared/utils/http";

export const loginCall = (data: any) => http.post("/auth/login", data);

export const autoLoginCall = (silent = false) =>
	http.get(`/me`, { suppressErrorToast: silent } as any);
export const abilitiesCall = () => http.get(`/auth/abilities`);
